module.exports = __webpack_public_path__ + "static/media/unlimited-features.7e97e67b.jpg";